<template>
  <div id="mobility">
    <header id='header' class="header">

      <div class="container header__container">
        <div class="logo__wrap">
          <router-link to="/">
            <img class="logo_header" :src="'./static/logo.png'">
          </router-link>
        </div>
        <nav class="menu-wrap">
          <ul class="menu">
            <li class="menu__item has-expand ">

              <router-link class="menu-link up-text menu__item__link services_tab" to="/sectors">Sectors</router-link>
              <div class="expand-menu">
                <ul class="expand-menu-list">
                  <li class="expand-menu-item" v-for="(item,index) in sectors" :v-key="item.slug" >
                    <router-link :to="'/sectors/' + item.slug " class="expand-menu-link" >
                      <div class="icon__wrap">
                        <picture>
                          <source data-srcset="../assets/img/purple-sphere-120.png" media="(min-width: 691px)" />
                          <img :src=" './static/sectors/' + item.image" alt="purple sphere" data-load-priority="1">
                        </picture>
                      </div>
                      <span> {{item.title}} </span>
                    </router-link>
                  </li>
                
                </ul>
              </div>
            </li>
            <!-- <li class="menu__item  s-hidden">
                    <a href="#" class="menu-link up-text menu__item__link">Company</a>
                </li> -->
            <li class="menu__item  s-hidden">
              <router-link class="menu-link up-text menu__item__link" to="/about">About</router-link>
            </li>
            <li class="menu__item  s-hidden">
              <router-link class="menu-link up-text menu__item__link" to="/news">News</router-link>
            </li>
            <li class="menu__item  s-hidden">
              <router-link class="menu-link up-text menu__item__link" to="/career">Career</router-link>
            </li>
            <li class="menu__item  s-hidden">
              <router-link class="menu-link up-text menu__item__link" to="/contact">
                Contact
              </router-link>
            </li>
          </ul>
        </nav>
        <a href="https://web.mobilityintel.com" class="button button--transparent-grad pulse ">Signup</a>
        <a href="https://web.mobilityintel.com/" class="button button--transparent-grad pulse d-hidden ">Login</a>

        <a href="https://web.mobilityintel.com/" class="menu-link up-text menu__item__link last s-hidden" >Login</a>
        <div class="burger-menu s-visible">
          <a href="#" id="mob-menu-link" @click="open=!open" class="burger-menu__link menu-link up-text hamburger">
            <span class="burger-menu__text">menu</span>
            <div class="burger-button">
              <span class="burger-button-dot"></span>
              <span class="burger-button-dot"></span>
              <span class="burger-button-dot"></span>
              <span class="burger-button-dot"></span>
              <span class="burger-button-dot"></span>
              <span class="burger-button-dot"></span>
              <span class="burger-button-dot"></span>
              <span class="burger-button-dot"></span>
              <span class="burger-button-dot"></span>
            </div>
          </a>
        </div>
      </div>


    </header>
    <!-- <router-view :to="{ name: 'layoutPage' }"></router-view> -->
    <div class="main-content">
      <transition name="fade" mode="out-in">
          <router-view />
      </transition>
    </div>
  

    <footer class="footer">
      <div class="container footer__container">
        <a href="#" class="logo logo--footer">

          <img src="../assets/img/1.png">

        </a>
        <nav class="footer-menu__wrap ">
          <ul class="footer-menu__list column">
            <!-- <li class="footer-menu__item">
                        <a href="#" class="footer-text up-text footer-menu__item__link">Products</a>
                    </li> -->
            <!-- <li class="footer-menu__item">
                        <a href="#" class="footer-text up-text footer-menu__item__link">Company</a>
                    </li> -->
            <!-- <li class="footer-menu__item">
                        <a href="blog" class="footer-text up-text footer-menu__item__link">Blog</a>
                    </li> -->
            <li class="footer-menu__item">
              <router-link to="/about" class="footer-text up-text footer-menu__item__link">
                About
              </router-link>
            </li>

            <li class="footer-menu__item">
              <router-link to="/sectors" class="footer-text up-text footer-menu__item__link">
                Sectors
              </router-link>
              
            </li>
            <li class="footer-menu__item">
              <router-link to="/career" class="footer-text up-text footer-menu__item__link">
                Career
              </router-link>
            </li>
            <li class="footer-menu__item">
              <router-link to="/contact" class="footer-text up-text footer-menu__item__link">
                Contact
              </router-link>
            </li>
            <li class="footer-menu__item">
              <router-link to="/news" class="footer-text up-text footer-menu__item__link">
                News
              </router-link>
            </li>
            <li class="footer-menu__item">
               <router-link to="/privacy" class="footer-text up-text footer-menu__item__link">
                Privacy
              </router-link>
            </li>
            <li class="footer-menu__item">
              <router-link to="/term" class="footer-text up-text footer-menu__item__link">
                Term
              </router-link>
            </li>
             <li class="footer-menu__item">
              <router-link to="/EULA" class="footer-text up-text footer-menu__item__link">
                EULA
              </router-link>
            </li>
          </ul>
        </nav>
        <div class="contact__wrap">
                <h4 class="footer-text up-text ">Address</h4>
                <div href="" class="call__link">
                  MI Inc <br>
                    30 Wall Street, 8th Floor<br>
                    New York City, NY 10005<br>

                </div>
            </div>
        <div class="social__wrap">
          <h4 class="footer-text up-text s-hidden">Follow us</h4>
          <div class="social-list">
            <a href="https://www.facebook.com/MobilityIntelGlobal" target="_BLANK" class="social-item" title="facebook">
              <i class="fa fa-facebook">
                <!-- Generator: Adobe Illustrator 23.0.0, SVG Export Plug-In  -->
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                  y="0px" width="15.2px" height="32.7px" viewBox="0 0 15.2 32.7"
                  style="enable-background:new 0 0 15.2 32.7;" xml:space="preserve">
                  <defs>
                  </defs>
                  <g>
                    <g>
                      <path class="st0" style="fill-rule:evenodd;clip-rule:evenodd;fill:#171917;" d="M3.3,16.5v15.8c0,0.2,0.2,0.4,0.4,0.4h5.9c0.2,0,0.4-0.2,0.4-0.4V16.2h4.3c0.2,0,0.4-0.2,0.4-0.4l0.4-4.8
                        c0-0.2-0.2-0.4-0.4-0.4H10V7.1c0-0.8,0.7-1.5,1.5-1.5h3.3c0.2,0,0.4-0.2,0.4-0.4V0.4C15.2,0.2,15,0,14.8,0H9.2
                        C6,0,3.3,2.6,3.3,5.9v4.7H0.4C0.2,10.6,0,10.7,0,11v4.8c0,0.2,0.2,0.4,0.4,0.4h2.9V16.5z" />
                    </g>
                  </g>
                </svg>
              </i>
            </a>
            <a href="https://twitter.com/MobilityIntel" target="_BLANK" class="social-item" title="twitter">
              <i class="fa fa-twitter">
                <!-- Generator: Adobe Illustrator 23.0.0, SVG Export Plug-In  -->
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                  y="0px" width="29.1px" height="23.9px" viewBox="0 0 29.1 23.9"
                  style="enable-background:new 0 0 29.1 23.9;" xml:space="preserve">

                  <defs>
                  </defs>
                  <g>
                    <g>
                      <g>
                        <path class="st0" style="fill:#171917;" d="M29,2.9C28,3.3,27,3.5,26,3.7c0.5-0.1,1.2-0.9,1.4-1.3c0.4-0.5,0.8-1.1,1-1.8c0-0.1,0-0.1,0-0.2
				c-0.1,0-0.1,0-0.2,0c-1.1,0.6-2.3,1-3.5,1.3c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.2-0.2-0.3-0.3c-0.5-0.4-1.1-0.8-1.7-1
				C21.8,0.1,20.9,0,20,0c-0.9,0.1-1.7,0.3-2.5,0.7c-0.8,0.4-1.4,1-2,1.6c-0.6,0.7-1,1.5-1.2,2.4c-0.2,0.8-0.2,1.7-0.1,2.5
				c0,0.1,0,0.2-0.1,0.1c-4.8-0.7-8.8-2.4-12-6.1C2,1.1,2,1.1,1.8,1.3c-1.4,2.1-0.7,5.5,1,7.2c0.2,0.2,0.5,0.4,0.7,0.6
				C3.5,9.1,2.4,9,1.3,8.4c-0.1-0.1-0.2,0-0.2,0.1c0,0.2,0,0.4,0,0.7c0.3,2.1,1.8,4.1,3.8,4.9c0.2,0.1,0.5,0.2,0.8,0.2
				c-0.5,0.1-0.9,0.2-2.3,0.1c-0.2,0-0.2,0.1-0.2,0.2c1,2.7,3.2,3.5,4.8,4c0.2,0,0.4,0,0.6,0.1c0,0,0,0,0,0
				c-0.5,0.8-2.4,1.4-3.3,1.7c-1.6,0.5-3.3,0.8-4.9,0.6c-0.3,0-0.3,0-0.4,0c-0.1,0,0,0.1,0.1,0.2c0.3,0.2,0.7,0.4,1,0.6
				c1.1,0.6,2.2,1,3.3,1.3c5.9,1.6,12.6,0.4,17.1-4c3.5-3.5,4.7-8.3,4.7-13.1c0-0.2,0.2-0.3,0.4-0.4c0.9-0.7,1.6-1.5,2.3-2.4
				c0.2-0.2,0.1-0.4,0.1-0.5c0,0,0,0,0,0C29.1,2.8,29.1,2.8,29,2.9z" />
                      </g>
                      <g>
                        <path class="st1" style="fill-rule:evenodd;clip-rule:evenodd;fill:#171917;"
                          d="M8.6,23.8C11.1,23.8,8.8,23.8,8.6,23.8C9,23.8,8.6,23.8,8.6,23.8z" />
                      </g>
                      <g>
                        <path class="st1" style="fill-rule:evenodd;clip-rule:evenodd;fill:#171917;"
                          d="M8.6,23.8C8.6,23.8,8.2,23.8,8.6,23.8C8.6,23.8,8.6,23.8,8.6,23.8z" />
                      </g>
                      <g>
                        <path class="st1" style="fill-rule:evenodd;clip-rule:evenodd;fill:#171917;"
                          d="M9.6,23.9C9.6,23.8,10.1,23.9,9.6,23.9C9.6,23.8,9.7,23.9,9.6,23.9z" />
                      </g>
                      <g>
                        <path class="st1" style="fill-rule:evenodd;clip-rule:evenodd;fill:#171917;"
                          d="M19.9,0c0,0-0.1,0-0.1,0C19.8,0,19.9,0,19.9,0z" />
                      </g>
                    </g>
                  </g>
                </svg>

              </i>
            </a>
            <a href="https://www.instagram.com/mobilityintel/" target="_BLANK" class="social-item" title="youtube">
              <i class="fa fa-youtube">
               <!-- Generator: Adobe Illustrator 23.0.0, SVG Export Plug-In  -->
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="21.3px"
                height="21.3px" viewBox="0 0 21.3 21.3" style="enable-background:new 0 0 21.3 21.3;" xml:space="preserve">

              <defs>
              </defs>
              <path class="st0" style=" fill:#171917;" d="M21.3,9.3c0-0.7,0-1.3,0-2c0-0.5,0-1.1-0.1-1.6c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c0-0.1-0.1-0.2,0-0.3
                c-0.1,0-0.1-0.1-0.1-0.1c-0.1-0.4-0.2-0.9-0.3-1.3c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0-0.1-0.1-0.2-0.1-0.3C20.5,3,20.3,2.7,20,2.3
                c-0.3-0.4-0.7-0.8-1.1-1.1c-0.2-0.2-0.5-0.3-0.7-0.4c-0.2-0.1-0.5-0.2-0.7-0.3c0,0,0,0,0,0c-0.1,0-0.2-0.1-0.3-0.1
                c-0.5-0.1-1-0.2-1.5-0.3c-0.5,0-0.9-0.1-1.4-0.1c-0.2,0-0.3,0-0.5,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.5,0-1,0-1.6,0
                C11,0,10.1,0,9.2,0c-0.5,0-1,0-1.4,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c-0.1,0-0.3,0-0.4,0c-0.2,0-0.5,0-0.8,0c-1.1,0-2.2,0.2-3.2,0.7
                c0,0-0.1,0-0.1,0c0,0,0,0,0,0C2.5,1.1,2,1.5,1.6,1.9C1.3,2.3,1,2.6,0.8,3C0.7,3.3,0.6,3.5,0.5,3.7c0,0,0,0,0,0c0,0.1,0,0.1,0,0.1
                C0.3,4.4,0.2,5.1,0.1,5.7c0,0.5-0.1,0.9-0.1,1.4c0,0.2,0,0.3,0,0.5c0,0,0,0.1,0,0.1C0,8,0,8.4,0,8.8c0,1.3,0,2.5,0,3.8
                c0,0.1,0,0.1,0,0.2c0,0.6,0,1.2,0,1.8c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
                c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2c0,0.2,0,0.4,0,0.6c0,0,0,0,0,0c0,0.1,0.1,0.2,0,0.2c0,0,0,0.1,0.1,0.1c0.1,0.4,0.2,0.8,0.3,1.2
                c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0.1,0.2,0.2,0.5,0.3,0.7c0.1,0.2,0.3,0.5,0.4,0.7c0.3,0.4,0.7,0.8,1.1,1.1c0.4,0.3,0.7,0.5,1.1,0.7
                c0.1,0,0.2,0.1,0.3,0.1c0.2,0.1,0.5,0.2,0.7,0.2c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0.4,0.1,0.9,0.2,1.4,0.2c0.4,0,0.7,0,1.1,0
                c0,0,0.1,0,0.1,0c0,0,0,0,0,0c1.4,0,2.9,0,4.3,0c0.8,0,1.6,0,2.3,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0c0,0,0,0,0,0c0-0.1,0.1,0,0.2-0.1
                c0.6,0,1.2,0,1.8-0.1c0.2,0,0.4-0.1,0.6-0.1c0,0,0,0,0.1,0c0.2-0.1,0.5-0.1,0.7-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0,0,0,0,0,0
                c0.2-0.1,0.5-0.2,0.7-0.4c0.3-0.2,0.6-0.4,0.8-0.6c0.4-0.3,0.7-0.7,0.9-1.1c0,0,0,0,0-0.1c0.1-0.2,0.3-0.5,0.4-0.7
                c0-0.1,0.1-0.2,0.1-0.4c0.1-0.2,0.1-0.5,0.2-0.7c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2c0-0.2,0.1-0.4,0.1-0.7c0,0,0-0.1,0-0.1c0,0,0,0,0,0
                c0-0.3,0-0.7,0.1-1c0-0.3,0-0.6,0-0.9C21.3,12.4,21.3,10.9,21.3,9.3z M19.4,8.2c0,1.7,0,3.4,0,5.1c0,0.1,0,0.2,0,0.3
                c0,0.3,0,0.6,0,1c0,0.1,0,0.3,0,0.4c0,0.1,0,0.2,0,0.3c0,0.2,0,0.4-0.1,0.6c-0.1,0.5-0.2,0.9-0.4,1.3c-0.1,0.2-0.2,0.5-0.4,0.7
                c-0.3,0.5-0.8,0.8-1.3,1.1c0,0-0.1,0-0.1,0c-0.3,0.2-0.7,0.3-1,0.3c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4,0.1-0.6,0.1h0c0,0,0,0,0,0
                c-0.2,0-0.3,0-0.5,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.3,0-0.6,0-0.9,0c-0.3,0-0.5,0-0.8,0
                c-0.3,0-0.7,0-1,0c-0.8,0-1.7,0-2.5,0c-0.2,0-0.5,0-0.7,0c-0.3,0-0.6,0-1,0c-0.3,0-0.7,0-1,0c0,0,0,0,0,0h0c0,0-0.1,0-0.1,0
                c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0
                c-0.2,0-0.4,0-0.7-0.1c-1.1-0.2-2-0.6-2.6-1.5c-0.3-0.5-0.5-1-0.6-1.6C2,15.7,2,15.2,2,14.8c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2
                c0,0,0-0.1,0-0.1c0-0.2,0-0.3,0-0.5c0,0,0,0,0,0c0-0.3,0-0.6,0-0.9c0-0.2,0-0.4,0-0.5v-0.1c0,0,0-0.1,0-0.1c0-0.2,0-0.4,0-0.5v-0.1
                c0-0.2,0-0.5,0-0.7c0-0.2,0-0.5,0-0.7c0-0.2,0-0.5,0-0.7c0,0,0-0.1,0-0.1c0-0.7,0-1.3,0-2c0-0.5,0-1,0.1-1.5C2.1,5,2.3,4.3,2.7,3.6
                C3.3,2.8,4,2.4,5,2.1C5.5,2,6.1,2,6.7,2c0.7,0,1.4,0,2.1,0c0.3,0,0.5,0,0.8,0h0c0.2,0,0.5,0,0.7,0h0c0.1,0,0.2,0,0.3,0
                c0.2,0,0.3,0,0.5,0c0.2,0,0.3,0,0.5,0c0.3,0,0.6,0,1,0c0.8,0,1.6,0,2.4,0.1C15.5,2,16,2,16.5,2.2c0.2,0.1,0.4,0.1,0.6,0.2
                C17.5,2.6,17.8,2.8,18,3c0.3,0.3,0.6,0.6,0.8,1c0.2,0.4,0.3,0.7,0.4,1.1c0,0.1,0,0.2,0,0.3c0,0.1,0,0.3,0.1,0.4c0,0,0,0,0,0
                c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0.1,0,0.3,0,0.4c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2
                c0,0.3,0,0.6,0,0.9C19.4,7.9,19.4,8.1,19.4,8.2z"/>
              <path class="st0" style=" fill:#171917;" d="M15.9,9.1c-0.1-0.4-0.3-0.8-0.5-1.1c-0.2-0.3-0.4-0.7-0.7-1c-0.4-0.5-0.9-0.9-1.5-1.2c-0.1-0.1-0.2-0.1-0.3-0.2
                c-0.3-0.2-0.7-0.3-1.1-0.4c-0.3-0.1-0.7-0.1-1-0.1c-0.5,0-0.9,0-1.4,0.1c0,0-0.1,0-0.1,0C8.7,5.5,8.1,5.7,7.6,6.1
                c-0.5,0.3-1,0.8-1.3,1.2C6.2,7.4,6.1,7.5,6.1,7.6C6,7.8,5.9,8,5.8,8.1C5.6,8.5,5.4,8.9,5.3,9.3c0,0.3-0.1,0.5-0.1,0.8
                c0,0.5,0,1,0.1,1.5c0,0,0,0.1,0,0.1c0.1,0.5,0.3,1,0.5,1.4c0.4,0.7,0.8,1.3,1.4,1.7c0.2,0.2,0.5,0.4,0.7,0.5
                c0.7,0.4,1.5,0.6,2.3,0.7c0.9,0.1,1.8-0.1,2.7-0.5c0.4-0.2,0.7-0.4,1-0.6c0.3-0.3,0.6-0.5,0.9-0.8c0.1-0.1,0.1-0.2,0.2-0.3
                c0,0,0,0,0,0c0.6-0.8,1-1.7,1.1-2.8C16.2,10.5,16.1,9.8,15.9,9.1z M14.1,11.5c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.3-0.4,0.6-0.6,0.9
                c-0.3,0.3-0.7,0.6-1.1,0.8C12,14,11.8,14,11.6,14.1c-0.8,0.2-1.6,0.2-2.3-0.1c-0.2-0.1-0.5-0.2-0.7-0.4c-0.4-0.3-0.7-0.6-1-1
                c-0.2-0.2-0.3-0.5-0.3-0.7c-0.1-0.1-0.1-0.3-0.1-0.4c-0.1-0.5-0.1-1.1,0-1.6c0-0.2,0.1-0.3,0.2-0.5c0.4-0.9,1-1.5,1.9-1.9
                c0.2-0.1,0.3-0.1,0.5-0.2c0.6-0.1,1.1-0.2,1.7,0c0.1,0,0.3,0.1,0.4,0.1c0.3,0.1,0.5,0.2,0.7,0.3c0.4,0.3,0.7,0.6,1,1
                c0.2,0.2,0.3,0.4,0.4,0.7C14.2,10.1,14.3,10.8,14.1,11.5z"/>
              <path class="st0" style=" fill:#171917;" d="M16.7,6.2c-0.5,0.1-0.9,0.1-1.3-0.3c-0.4-0.4-0.5-0.8-0.4-1.3c0.1-0.5,0.5-0.8,1-0.9c1-0.2,1.7,0.7,1.4,1.7
                c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c-0.1,0.3-0.4,0.5-0.7,0.6C16.8,6.2,16.8,6.2,16.7,6.2z"/>
              </svg>


              </i>
            </a>
            <a href="https://www.linkedin.com/company/mobilityintel/" target="_BLANK" class="social-item" title="linkedin">
              <i class="fa fa-linkedin">

                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                  y="0px" width="28.8px" height="27.5px" viewBox="0 0 28.8 27.5"
                  style="enable-background:new 0 0 28.8 27.5;" xml:space="preserve">

                  <defs>
                  </defs>
                  <g>
                    <g>
                      <g>
                        <g>
                          <path class="st0" style="fill:#171917;" d="M28.8,16.9V27c0,0.3-0.2,0.5-0.5,0.5h-5.3c-0.3,0-0.5-0.2-0.5-0.5v-9.5c0-2.5-0.9-4.2-3.1-4.2
                            c-1.7,0-2.7,1.1-3.2,2.3c-0.2,0.4-0.2,0.9-0.2,1.5V27c0,0.3-0.2,0.5-0.5,0.5h-5.3c-0.3,0-0.5-0.2-0.5-0.5c0-2.5,0.1-14.7,0-17.6
                            C10,9.2,10.2,9,10.4,9h5.2c0.3,0,0.5,0.2,0.5,0.5v2.2c0,0,0,0,0,0.1h0v-0.1c0.8-1.3,2.3-3.1,5.6-3.1
                            C25.7,8.5,28.8,11.2,28.8,16.9L28.8,16.9z M0.9,27.5h5.3c0.3,0,0.5-0.2,0.5-0.5V9.4C6.6,9.2,6.4,9,6.1,9H0.9
                            C0.6,9,0.4,9.2,0.4,9.4V27C0.4,27.3,0.6,27.5,0.9,27.5z" />
                        </g>
                      </g>
                    </g>
                    <g>
                      <g>
                        <circle class="st0" cx="3.3" cy="3.3" r="3.3" />
                      </g>
                    </g>
                  </g>
                </svg>
              </i>
            </a>
          </div>
        </div>
      </div>
      <div class="copy">
        Copyright © MI, Inc. All right reserved
      </div>
    </footer>

    <div id="mobile-menu" :class="{'opend':open}">
      <div class="close-btn-wrap" id="close-mob-menu" @click="open=!open" style="">
        <a href="#" class="burger-menu__link menu-link up-text">
          <span class="burger-menu__text">close</span>
          <div class="burger-button">
            <span class="burger-button-dot"></span>
            <span class="burger-button-dot"></span>
            <span class="burger-button-dot"></span>
            <span class="burger-button-dot"></span>
            <span class="burger-button-dot"></span>
            <span class="burger-button-dot"></span>
            <span class="burger-button-dot"></span>
            <span class="burger-button-dot"></span>
            <span class="burger-button-dot"></span>
          </div>
        </a>
      </div>
      <div id="mobile-menu-sail-l" class="mobile-menu-sail" style="transform: matrix(1, 0, 0, 1, 0, 0);"></div>
      <div id="mobile-menu-sail-r" class="mobile-menu-sail" style="transform: matrix(1, 0, 0, 1, 0, 0);"></div>
      <ul id="mobile-menu-list" class="mobile-menu-links-list" style="">
        <li class="mobile-menu-link-wrap oh" @click="open=false">
          <router-link to="/about" class="mobile-menu-link mobile-menu-link-first-lvl md-title">
            About
          </router-link>
        </li>
        <li class="mobile-menu-link-wrap oh" @click="open=false">
          <router-link to="/sectors" class="mobile-menu-link mobile-menu-link-first-lvl md-title">
            Sectors
          </router-link>
        </li>

        <li class="mobile-menu-link-wrap oh" @click="open=false">
          <router-link to="/career" class="mobile-menu-link mobile-menu-link-first-lvl md-title">
            Career
          </router-link>
        </li>
        <li class="mobile-menu-link-wrap oh" @click="open=false">
          <router-link to="/news" class="mobile-menu-link mobile-menu-link-first-lvl md-title">
            News
          </router-link>
        </li>

        <li class="mobile-menu-link-wrap oh" @click="open=false">
          <router-link to="/contact" class="mobile-menu-link mobile-menu-link-first-lvl md-title">
            Contact
          </router-link>
        </li>
      </ul>
    </div>

   <div class="toast" v-show="toastOpen">
          <div class="toast_header">
       
               <img class="toast_header__icon" src="/static/cdn/alert_ldoekr.svg">
               <span class="toast_header__title">Join the newsletter
              </span>
               <span class="toast_header__close" @click="closeStoast">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10.4px" height="10.4px" viewBox="0 0 10.4 10.4" style="enable-background:new 0 0 10.4 10.4;" xml:space="preserve"> <defs> </defs> <g> <path style="fill:#FFFFFF;" d="M9.4,0c0.1,0,0.1,0,0.2,0c0.3,0.1,0.5,0.4,0.7,0.6c0.2,0.2,0.1,0.5-0.1,0.8C9,2.6,7.7,3.9,6.5,5.1 c0,0-0.1,0.1-0.1,0.1c0,0,0.1,0,0.1,0.1C7.7,6.6,9,7.8,10.2,9.1c0,0,0.1,0.1,0.1,0.1c0.2,0.2,0.2,0.5,0,0.6 c-0.2,0.2-0.3,0.4-0.5,0.5c-0.2,0.2-0.5,0.1-0.7-0.1C7.8,9,6.6,7.7,5.3,6.5c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0.1-0.1,0.1 C3.9,7.7,2.6,9,1.4,10.2c0,0-0.1,0.1-0.1,0.1c-0.2,0.2-0.5,0.2-0.7,0C0.4,10.1,0.1,9.9,0,9.6c0-0.1,0-0.1,0-0.2 C0.1,9.2,0.2,9.1,0.3,9C1.5,7.8,2.8,6.5,4,5.3c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0c0,0-0.1,0-0.1-0.1C2.8,3.9,1.5,2.7,0.3,1.5 C0.2,1.3,0.1,1.2,0,1C0,1,0,0.9,0,0.8C0.2,0.4,0.4,0.2,0.8,0C0.9,0,1,0,1,0c0.2,0.1,0.3,0.2,0.4,0.3C2.7,1.5,3.9,2.8,5.1,4 c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0-0.1,0.1-0.1C6.5,2.8,7.7,1.5,9,0.3C9.1,0.2,9.2,0.1,9.4,0z"/> </g> </svg>
               </span>
          </div>
          <div class="toast_body">
            <p>Receive the latest content from MI by subscribing to the newsletter.
            </p>
              <router-link  @click.native="scrollToBottom" :to="{ path: '/', hash: '#subscription' }" class="button button--white-hover-grad button--submit pulse">
                Subscribe
              </router-link>
          </div>
          

      </div>
  </div>
</template>

<script>
  import VueRouter from 'vue-router';
  import dataSectors from '@/assets/data/sectors'

    import aos from 'aos/dist/aos.js';
  export default {
    name: 'layoutPage',
    components: {
      VueRouter
    },
    data() {
      return {
        open: false,
        servicestab: false,
        toastOpen:true,
        sectors:dataSectors.data
      }
    },
    metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'MI',
      // all titles will be injected into this template
      titleTemplate: '%s | A B2B Customized Solutions company that takes advantage of machine learning, AI, and a in house developed pricing engine to increase profitability & productivity.'
    },
    methods: {
      getHost(){
        return location.host;
      },
      scrollToBottom(){
        setTimeout(function(){
          $('html, body').animate({
                    scrollTop: $("#subscription").offset().top
                }, 2000);
        },1000)
          this.closeStoast()
      },
      servicestabMethod() {
        console.log("---servicestabMethod--");
      },
      closeStoast(){
        this.toastOpen = false;
      }
    },
    mounted() {
          aos.init();
      var _this = this;
      $("li.menu__item.has-expand").hover(function () {
        $(this).addClass("active")
      },function(){
         $(this).removeClass("active")
      })

      $(document).mouseup(function (e) {
        var container = $(".menu__item.has-expand");

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          container.removeClass("active");
        }
      });
    }
  };

</script>
<style src='aos/dist/aos.css'>

</style>
<style lang="scss">
  @import './assets/style/global.scss';

  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }
.copy {
    color: #ffffff82;
    text-align: center;
    font-weight: 100;
    background-color: #ffffff03;
    padding: 15px 0;
}
</style>



// WEBPACK FOOTER //
// src/layoutPage.vue